// Text of an explanation step: the localised `text` written by the engine, or the generic i18n fallback of its
// `code` (FIND_MARKER, TAKE_NEXT…). Unknown code without text: nothing (the step is not shown).
export const STEP_CODES = Object.freeze([
    'FIND_MARKER', 'TAKE_NEXT', 'TAKE_PREVIOUS', 'TAKE_MATCHING', 'SKIP', 'COPY_ALL', 'NOTHING_TO_TYPE',
]);

export const stepText = (step, formatMessage) => {
    if (!step) return null;
    if (typeof step.text === 'string' && step.text.trim() !== '') return step.text;
    if (STEP_CODES.indexOf(step.code) !== -1) return formatMessage({ id: `conventionPage.step.${step.code}` });
    return null;
};
